/* Hey Hottie — cart auto-ship control  (v4)
 *
 * Converts a one-time cart line to an Appstle subscription, changes the
 * interval, or takes it back off.
 *
 * Everything routes through Shopify's own /cart/change.js, so Appstle sees a
 * normal selling-plan change and nothing here needs to know how Appstle works.
 *
 * ── on repainting the cart ────────────────────────────────────────────────
 * Stiletto refreshes its own drawer through an internal pub/sub that is not
 * exposed on window, so we cannot ask it to redraw.
 *
 * v3 tried the Ajax API's `sections` parameter and swapped the returned HTML
 * in. It broke the theme's cached DOM references. v4 reverts to a plain
 * reload, which flashes — and that is the honest trade: a cart that repaints
 * wrongly is far worse than one that repaints slowly.
 * ─────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var BUSY = 'hh-autoship--busy';

  function root() {
    return ((window.Shopify && window.Shopify.routes) || {}).root || '/';
  }

  function showError(el, message) {
    var box = el.closest('[data-hh-autoship]');
    var slot = box && box.querySelector('[data-hh-autoship-error]');
    if (!slot) return;
    slot.textContent = message;
    slot.hidden = false;
  }

  function apply(el, sellingPlan) {
    var box = el.closest('[data-hh-autoship]');
    if (!box) return;
    var line = parseInt(box.getAttribute('data-line'), 10);
    if (!line) return;

    box.classList.add(BUSY);
    var slot = box.querySelector('[data-hh-autoship-error]');
    if (slot) slot.hidden = true;

    fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, selling_plan: sellingPlan })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Cart update failed');
          return data;
        });
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function (err) {
        box.classList.remove(BUSY);
        showError(el, 'Could not change that just now.');
        console.warn('[hey hottie] auto-ship change failed:', err);
      });
  }

  document.addEventListener('click', function (e) {
    var on = e.target.closest('[data-hh-autoship-on]');
    if (on) {
      e.preventDefault();
      apply(on, on.getAttribute('data-plan'));
      return;
    }
    var off = e.target.closest('[data-hh-autoship-off]');
    if (off) {
      e.preventDefault();
      /* An empty string is how Shopify clears a selling plan. */
      apply(off, '');
    }
  });

  /* Add straight from the snagging board — one tap, either as a one-time
     purchase or already on auto-ship. Making someone open a product page to
     subscribe is where the intent gets lost. */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-hh-add]');
    if (!add) return;
    e.preventDefault();
    var row = add.closest('.hh-snag__row') || add;
    row.classList.add('hh-snag--busy');
    var body = { id: add.getAttribute('data-hh-add'), quantity: 1 };
    var plan = add.getAttribute('data-hh-plan');
    if (plan) body.selling_plan = plan;

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().then(function (d) {
          if (!res.ok) throw new Error(d.description || d.message || 'Could not add');
          return d;
        });
      })
      .then(function () { window.location.reload(); })
      .catch(function (err) {
        row.classList.remove('hh-snag--busy');
        console.warn('[hey hottie] add failed:', err);
      });
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-hh-autoship-interval]');
    if (sel) apply(sel, sel.value);
  });
})();
